import { type CSSProperties, type FC } from 'react'
import { cn } from '@/lib/utils'
import { SPRITE_HREF } from '@/icons/sprite'

type IconProps = {
  name: string
  size?: number
  className?: string
  style?: CSSProperties
  strokeWidth?: number
}

export const Icon: FC<IconProps> = ({
  name,
  size = 18,
  className = '',
  style = {},
  strokeWidth,
}) => {
  return (
    <div
      className={cn('shrink-0', className)}
      style={{
        width: size,
        height: size,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        ...style,
      }}
      aria-hidden="true"
    >
      <svg
        width={size}
        height={size}
        style={{
          display: 'block',
          ...(strokeWidth ? ({ '--icon-stroke-width': strokeWidth } as CSSProperties) : {}),
        }}
      >
        <use href={`${SPRITE_HREF}#${name}`} />
      </svg>
    </div>
  )
}
